import * as Constants from '../constants/promotion';

const initialState = {
  activePromotionCode: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Constants.GET_PROMOTION_CODE_SUCCESS:
      return {
        ...state,
        activePromotionCode: action.payload,
      };
    case Constants.SET_ACTIVE_PROMOTION_CODE:
      return {
        ...state,
        activePromotionCode: action.payload,
      };
    default:
      return state;
  }
};
